// extracted by mini-css-extract-plugin
export default {"labelInfoPassword":"FormSimplePassword_labelInfoPassword__ZY8j7"};